import { Component, OnInit, OnDestroy } from '@angular/core';
import { AbstractField } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/abstract-field';
import { filter, take, map, switchMap } from 'rxjs/operators';
import { AdditionalService, Order } from '@cemex-core/cmx-api';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { Store } from '@ngrx/store';
import { OneClickUpdateOrderAction } from '@ordersnproducts/modules/one-click-order/actions/one-click-orders.actions';
import { getOneClickAdditionalServices } from '@ordersnproducts/modules/one-click-order/selectors/one-click-additional-services.selector';
import { getOneClickSelectedOrder } from '@ordersnproducts/modules/one-click-order/selectors/one-click-orders.selector';

@Component({
  selector: 'additional-service',
  styleUrls: ['additional-service.component.scss'],
  templateUrl: 'additional-service.component.html',
})
export class AdditionalServices extends AbstractField implements OnInit, OnDestroy {
  public additionalServicesAvailable: AdditionalService[] = [];

  constructor(private store: Store<State>) {
    super();
  }

  ngOnInit(): void {
    this.initAdditionalServices();
  }

  ngOnDestroy(): void {
    this.resetOrderAdditionalServices();
  }

  private initAdditionalServices() {
    return this.store
      .select(getOneClickAdditionalServices)
      .pipe(filter(services => !!services))
      .subscribe(services => (this.additionalServicesAvailable = [...services]));
  }

  private resetOrderAdditionalServices() {
    this.store
      .select(getOneClickSelectedOrder)
      .pipe(
        take(1),
        filter((order => !! order)),
        )
      .subscribe(order => {
        const orderUpdated: Order = {
          ...order,
          items: order.items.map(item => {
            return {
              ...item,
              orderItemProfile: {
                ...item.orderItemProfile,
                additionalServices: [],
              },
            };
          }),
        };
        this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
      });
  }

  public additionalServiceChecked(checked: boolean, service: AdditionalService) {
    this.store
      .select(getOneClickAdditionalServices)
      .pipe(
        filter(additionalServices => !!additionalServices.length),
        take(1),
        map(additionalServices =>
          additionalServices.find(item => item.additionalServiceId === service.additionalServiceId),
        ),
        switchMap(additionalService =>
          this.store.select(getOneClickSelectedOrder).pipe(
            take(1),
            map(order => ({ order, additionalService })),
          ),
        ),
      )
      .subscribe(({ order, additionalService }) => {
        if (checked) {
          const orderUpdated: Order = {
            ...order,
            items: order.items.map(item => {
              return {
                ...item,
                orderItemProfile: {
                  ...item.orderItemProfile,
                  additionalServices: [
                    {
                      additionalServiceCode: additionalService.additionalServiceCode,
                      additionalServiceDesc: additionalService.additionalServiceDesc,
                      additionalServiceId: additionalService.additionalServiceId,
                    },
                  ],
                },
              };
            }),
          };
          this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
        } else if (!checked) {
          const orderUpdated: Order = {
            ...order,
            items: order.items.map(item => {
              return {
                ...item,
                orderItemProfile: {
                  ...item.orderItemProfile,
                  additionalServices: [],
                },
              };
            }),
          };
          this.store.dispatch(new OneClickUpdateOrderAction(orderUpdated));
        }
      });
  }
}
